// components/profile/ResponsiveSidebar.js - Complete replacement
import React, { useEffect } from "react";

const ResponsiveSidebar = ({ children, isOpen, toggleSidebar }) => {
  // Prevent body scroll when sidebar is open on mobile
  useEffect(() => {
    if (isOpen && window.innerWidth <= 768) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);
  
  // Debug sidebar state
  useEffect(() => {
    console.log("Sidebar isOpen state changed to:", isOpen);
  }, [isOpen]);
  
  // Close sidebar when clicking outside on mobile
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isOpen && window.innerWidth <= 768) {
        // Check if click is outside sidebar and not on toggle buttons
        const sidebar = document.querySelector('.profile-sidebar');
        const toggleBtns = document.querySelectorAll('.sidebar-toggle');
        
        const isOnToggleBtn = Array.from(toggleBtns).some(btn => btn.contains(e.target));
        
        if (sidebar && !sidebar.contains(e.target) && !isOnToggleBtn) {
          console.log("Click outside sidebar detected");
          toggleSidebar();
        }
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, toggleSidebar]);
  
  // Handle escape key to close sidebar
  useEffect(() => {
    const handleEscKey = (e) => {
      if (e.key === 'Escape' && isOpen) {
        toggleSidebar();
      }
    };
    
    document.addEventListener('keydown', handleEscKey);
    
    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isOpen, toggleSidebar]);
  
  return (
    <div className={`profile-sidebar ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-toggle-container">
        <button 
          className="sidebar-toggle" 
          onClick={(e) => {
            e.stopPropagation(); // Prevent event bubbling
            toggleSidebar();
          }}
          aria-label="Close sidebar"
        >
          ×
        </button>
      </div>
      {children}
    </div>
  );
};

export default ResponsiveSidebar;